import { jwtDecode } from "jwt-decode";

type PermissionInfoItem = {
  roleCode?: number;
  roleCodeName?: string;
};

type DecodedToken = {
  permission_info?: string | PermissionInfoItem[];
};

const SUPER_ADMIN_ROLE_CODE = 0;
const SUPER_ADMIN_ROLE_NAME = "ROLE_ADMIN_SUPER";

export const getPermissionInfoFromToken = (token?: string | null): PermissionInfoItem[] => {
  if (!token) return [];

  try {
    const decodedToken = jwtDecode<DecodedToken>(token);
    const rawPermissionInfo = decodedToken.permission_info;

    if (!rawPermissionInfo) return [];

    return Array.isArray(rawPermissionInfo)
      ? rawPermissionInfo
      : JSON.parse(rawPermissionInfo);
  } catch {
    return [];
  }
};

export const isSuperAdminByToken = (token?: string | null): boolean =>
  getPermissionInfoFromToken(token).some(
    (permission) =>
      permission.roleCode === SUPER_ADMIN_ROLE_CODE ||
      permission.roleCodeName === SUPER_ADMIN_ROLE_NAME,
  );

export const isSuperAdminFromStorage = (): boolean => {
  if (typeof window === "undefined") return false;

  const token = localStorage.getItem("newToken") || localStorage.getItem("token");
  return isSuperAdminByToken(token);
};
